import { Button, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { FiCheckSquare, FiMessageSquare } from 'react-icons/fi'
import { Card } from '../../shared'
import { formatSlotTime } from '../scheduler/lobbyScheduleUtils'
import { smsNudgeHref, type BoardCard } from './dayOfBoardModel'
import type { DayOfLeadDto, ScheduleLegislatorRowDto } from '../../../types/lobbyDay'

interface ReportBackChecklistProps {
  owed: BoardCard[]
  leadsByAssignment: Map<string, DayOfLeadDto>
  legislatorById: Map<string, ScheduleLegislatorRowDto>
  onRecord: (meetingId: string) => void
}

/** The "who still owes me a report-back" punch list, pinned above the board's sections. */
export function ReportBackChecklist({ owed, leadsByAssignment, legislatorById, onRecord }: ReportBackChecklistProps) {
  if (owed.length === 0) return null
  return (
    <Card p={4} mb={4} as="section" aria-labelledby="dayof-checklist-heading">
      <Heading id="dayof-checklist-heading" size="sm" mb={2}>Collect report-backs ({owed.length})</Heading>
      <VStack align="stretch" gap={2}>
        {owed.map(({ meeting, lead }) => {
          const name = legislatorById.get(meeting.legislatorId)?.fullName ?? 'Unknown legislator'
          const contact = lead ? leadsByAssignment.get(lead.assignmentId) : undefined
          const nudgeHref = contact ? smsNudgeHref(contact, name, meeting.startTime) : null
          return (
            <HStack key={meeting.id} justify="space-between" flexWrap="wrap" gap={2}>
              <Text fontSize="sm" minW={0} flex="1 1 180px">
                {`${name} · ${formatSlotTime(meeting.startTime)} · ${lead ? lead.fullName : 'No team lead'}`}
              </Text>
              <HStack gap={2}>
                {nudgeHref && (
                  <Button asChild size="sm" variant="outline" minH="44px">
                    <a href={nudgeHref}><FiMessageSquare />Nudge</a>
                  </Button>
                )}
                <Button size="sm" colorPalette="brand" minH="44px" onClick={() => onRecord(meeting.id)}>
                  <FiCheckSquare />Record report
                </Button>
              </HStack>
            </HStack>
          )
        })}
      </VStack>
    </Card>
  )
}
